<template>
  <div v-if="site" class="padded">

    <el-row>
      <el-col :span="24">
        <h1>{{rowData.siteName}}</h1>&nbsp;<h4>{{rowData.siteId}}</h4>
        <span v-if="!site.address">Council&nbsp;<strong>{{site.zone}}</strong></span>
      </el-col>

    </el-row>

    <el-row>
      <el-col :span="12">
        <i>{{site.subdistrict}}</i> <i v-if="site.district"><span v-if="site.subdistrict">, </span>{{site.district}}</i>
        <i v-if="site.region"><span v-if="site.district || site.subdistrict">, </span>{{site.region}}</i>
        <i v-if="site.state"><span v-if="site.district || site.subdistrict || site.region">, </span>{{site.state}}</i>
        <i v-if="site.country"><span v-if="site.district || site.subdistrict || site.region || site.state">, </span>{{site.country}}</i>
      </el-col>
    </el-row>

    <el-row v-if="site.address">
      <el-col :span="14">
        <strong>{{site.address}}</strong>&nbsp;&nbsp;
        Local Council&nbsp;<strong>{{site.zone}}</strong>
      </el-col>

      <el-col :span="10">
        <small>lat:</small>&nbsp;<strong>{{site.latitude}}</strong> / <small>lng:</small>&nbsp;<strong>{{site.longitude}}</strong>
      </el-col>
    </el-row>

    <el-tabs v-if="!isEmptyObject(action)" type="card" stretch>
<!--
      <el-tab-pane>

      <span slot="label"><i class="fa fa-list"></i> Summary</span>

       <progress-summary title="New Submission" v-model="action.steps[0]" />

       <progress-summary title="New Site" v-model="action.steps[1]" />

       <progress-summary title="Renewal" v-model="action.steps[2]" />

     </el-tab-pane>
-->
      <el-tab-pane>
        <span slot="label"><i class="fa fa-file"></i> {{action.steps[0].stepName}}</span>
        <progress-step1 :site-id="rowData.site_id" :row-data="action" :step-data="action.steps[0]" :read-only="true" />
      </el-tab-pane>

      <el-tab-pane lazy>
        <span slot="label"><i class="fa fa-edit"></i> {{action.steps[1].stepName}}</span>
        <Progress-step2 :site-id="rowData.site_id" :row-data="action"  :step-data="action.steps[1]" :read-only="true" />
      </el-tab-pane>

      <el-tab-pane lazy>
        <span slot="label"><i class="fa fa-list"></i> {{action.steps[2].stepName}}</span>
        <progress-step3  :site-id="rowData.site_id" :row-data="action" :step-data="action.steps[2]" :read-only="true" />
      </el-tab-pane>

      <el-tab-pane lazy>
        <span slot="label"><i class="fa fa-recycle"></i> {{action.steps[3].stepName}}</span>
        <progress-step4  :site-id="rowData.site_id" :row-data="action" :step-data="action.steps[3]" :read-only="true" />
      </el-tab-pane>



      <el-tab-pane lazy>
        <span slot="label"><i class="fa fa-home"></i> Land Owner</span>
        <el-row>
          <el-col :span="14">
            <h2>Land Owner</h2>

            <div v-if="!hasLandowner(site)">
              <center>
                <h3 class="subtitle">No landowner information found</h3>
              </center>
            </div>
            <div v-else>
              <el-row>
                <el-col :span="4">
                  Owner
                </el-col>

                <el-col :span="20">
                  <strong>{{site.tenancy.owner.name}}</strong>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="4">
                  Address
                </el-col>
                <el-col :span="20">
                  <strong>{{site.tenancy.owner.address}}</strong>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="4">
                  Post Code
                </el-col>
                <el-col :span="20">
                  <strong>{{site.tenancy.owner.postCode}}</strong>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="4">
                  Phone
                </el-col>
                <el-col :span="20">
                  <strong>{{site.tenancy.owner.phone}}</strong>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="4">
                  e-Mail
                </el-col>
                <el-col :span="20">
                  <strong>{{site.tenancy.owner.email}}</strong>
                </el-col>
              </el-row>

            </div>
            <br />
            <table v-if="site.landStarted" class="el-table">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Date</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tfoot>
              </tfoot>
              <tbody>
                <tr>
                  <td>{{site.landType}} Agreement</td>
                  <td><strong :class="isOverdue(site.landExpiry) ? 'text-primary' : 'text-success'">{{formatDate(site.landStarted)}}</strong></td>
                  <td></td>
                </tr>
                <tr>
                  <td>Deposit Paid</td>
                  <td></td>
                  <td>{{formatNumber(site.landDeposit)}}</td>
                </tr>
                <tr>
                  <td>{{site.frequency}} Rental</td>
                  <td></td>
                  <td>{{formatNumber(site.landPayment)}}</td>
                </tr>
                <tr>
                  <td>Agreement Expiry</td>
                  <td><strong :class="isOverdue(site.landExpiry) ? 'text-warning' : 'text-primary'">{{formatDate(site.landExpiry)}}</strong> <i>({{formatFriendlyDate(site.landExpiry)}})</i></td>
                  <td></td>
                </tr>
                <tr>
                  <td>Renewal Increment</td>
                  <td>
                    <span v-if="site.term">
                      <strong>{{site.term}}</strong>
                      {{site.term > 1 ? 'times' : 'time'}}
                    </span>
                  </td>
                  <td><strong>{{formatNumber(site.renewalIncrement)}}</strong> %</td>
                </tr>
              </tbody>
            </table>

          </el-col>

    </el-row>
  </el-tab-pane>
<!--
  <el-tab-pane lazy>
    <span slot="label"><i class="fa fa-users"></i> Sharers</span>
    <site-sharers :no-add="true" :read-only="true" :row-data="rowData"></site-sharers>
  </el-tab-pane>
-->
</el-tabs>
<hr>

<el-row>
  <el-col :span="8">
    <small  v-if="site.handover">Handover </small>&nbsp;
    <strong v-if="site.handover">{{formatDate(site.handover)}}</strong>
    </el-col

    <el-col :span="7" :offset="1">
      <small v-if="site.landExpiry">Land Expiry </small>&nbsp;
      <strong  v-if="site.landExpiry">{{formatDate(site.landExpiry)}}</strong>
    </el-col>

    <el-col :span="7" :offset="1">
      &nbsp;<small v-if="site.billing">Commencement</small>
      <strong v-if="site.billing">{{formatDate(site.billing)}}</strong>
    </el-col>

  </el-row>


</div>
</template>

<script>

import PermitMixins from '@/mixins/PermitMixins'

import SiteSharers from '@/components/sites/SiteSharers'
import LandAgreement from '@/components/property/LandAgreement'

import ProgressSummary from '@/components/progress/ProgressSummary'

import ProgressStep1 from '@/components/progress/ProgressStep1'
import ProgressStep2 from '@/components/progress/ProgressStep2'
import ProgressStep3 from '@/components/progress/ProgressStep3'
import ProgressStep4 from '@/components/progress/ProgressStep4'

export default {
  mixins: [PermitMixins],

  components: {
    ProgressSummary,
    SiteSharers,
    LandAgreement,
    ProgressStep1,
    ProgressStep2,
    ProgressStep3,
    ProgressStep4
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },

  methods: {
    fillSite (data) {
      this.site = data
    },

    fillStep (data) {
      this.action = data
    }
  },

  data () {
    return {
      site: null,
      action: null
    }
  },

  created () {
    this.findSite(this.rowData.site_id, this.fillSite)
    this.fetchData('/actions/' + this.rowData.id, this.fillStep)
  }
}
</script>
